export default (existingClass, variable) => {
    return existingClass + (variable ? ' disabled' : '');
};
